import classNames from 'classnames';
import { kebabCase } from 'lodash';
import React from 'react';
import { Fund } from 'src/components/Exchange/types';
import Note from 'src/components/Shared/Note/Note';
import ToolTip from 'src/components/Shared/ToolTip/ToolTip';
import { orEmpty } from 'src/utils/utils';
import '../ExpandedFundHeader.scss';

export interface FundTitleProps
  extends Pick<
    Fund,
    'agreementNumber' | 'fundName' | 'ticker' | 'linkedAgreementNumber'
  > {
  formattedEntityNames?: string;
  isNewFund?: boolean;
  isSelected?: boolean;
  showDistributionNote?: boolean;
  showSweep?: boolean;
  showTicker?: boolean;
}
export const FundTitle: React.FC<FundTitleProps> = ({
  agreementNumber,
  formattedEntityNames,
  fundName = '',
  isNewFund,
  isSelected,
  linkedAgreementNumber,
  showDistributionNote,
  showSweep,
  showTicker,
  ticker = '',
}) => {
  return (
    <>
      <header className="standalone-fund-title">
        <span
          className={classNames('expanded-fund-header-name', 'e2e-fund-name')}
        >
          {fundName}
        </span>
        {showTicker && (
          <span
            className={classNames(
              'expanded-fund-header-ticker',
              'e2e-ticker-name'
            )}
          >
            {ticker}
          </span>
        )}
        {showSweep && (
          <span
            className={classNames(
              'expanded-fund-header-sweep',
              'e2e-fund-sweep'
            )}
            id={`sweep-${ticker}`}
          >
            <span className="expanded-fund-header-sweep_text">Sweep</span>
            <ToolTip
              header="Sweep Account"
              message={
                <div className="exclude">
                  <p className="exclude">
                    This Money Market fund is linked to your Brokerage Account{' '}
                    <span className="exclude blocked_data text-nowrap">
                      #{linkedAgreementNumber}.
                    </span>
                  </p>
                  <p className="exclude expanded-fund-header-sweep-tip-para">
                    Securities transactions and/or cash distributions from
                    positions held in that specific brokerage account will
                    settle in or out of this "sweep" account.
                  </p>
                </div>
              }
            />
          </span>
        )}

        <div
          className={classNames(
            `e2e-fund-header-second-line-${kebabCase(ticker)}`,
            { 'expanded-fund-header-selected': isSelected }
          )}
        >
          <span className={'blocked_data text-nowrap expanded-fund-header'}>
            {isNewFund ? 'Just Added' : orEmpty(agreementNumber)}
          </span>
          <span
            className="expanded-fund-header-user"
            title={formattedEntityNames}
          >
            •{' '}
            <span className="blocked_data">
              {orEmpty(formattedEntityNames)}
            </span>
          </span>
        </div>
      </header>
      {showDistributionNote && (
        <Note className="expanded-fund-header-exch-rmd-notes" title="Note:">
          The distribution you are requesting may help satisfy all or a portion
          of your required minimum distribution (RMD) for a given year. RMDs are
          waived in 2020 as a result of the CARES Act.
        </Note>
      )}
    </>
  );
};
